import React from 'react';
export default function DragAndDropIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.375 10.9205C3.375 10.4934 3.72128 10.1471 4.14844 10.1471H13.8516C14.2787 10.1471 14.625 10.4934 14.625 10.9205C14.625 11.3477 14.2787 11.694 13.8516 11.694H4.14844C3.72128 11.694 3.375 11.3477 3.375 10.9205Z" fill="#373737"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.375 7.54553C3.375 7.11837 3.72128 6.77209 4.14844 6.77209H13.8516C14.2787 6.77209 14.625 7.11837 14.625 7.54553C14.625 7.97269 14.2787 8.31897 13.8516 8.31897H4.14844C3.72128 8.31897 3.375 7.97269 3.375 7.54553Z" fill="#373737"/>
    </svg>
  );
}